import React, { useState } from 'react';

// Email Template Page
const EmailPage = () => {
  const [copied, setCopied] = useState(null);

  const emails = {
    zammariello: {
      destinatario: "Andrea Zammariello — Il Marketing della Felicità",
      oggetto: "LOCALS — AI_COVO.tech® ha bisogno delle tue mani, Andrea",
      corpo: `Andrea,

mi chiamo Riccardo Rossi, sono il Co-Founder di AI_COVO.tech® — il primo Digital Hub Sociale d'Italia, nato a Colle Val d'Elsa.

Ti scrivo perché non cerco un social media manager.
Cerco IL social media manager. E chi conosce il territorio sa che quel nome, qui tra Poggibonsi e la Val d'Elsa, sei tu.

Ho studiato il tuo approccio. Il "Marketing della Felicità" non è un claim — è una filosofia. Ed è esattamente quella che serve ad AI_COVO. Noi non vendiamo nulla: costruiamo comunità. Doposcuola per ragazzi, alfabetizzazione digitale per anziani, spazi per famiglie ISEE basso, formazione per chi è rimasto indietro.

Empatia, reciprocità, gratitudine, cooperazione — i tuoi pilastri sono i nostri.

La parola in codice è LOCALS.
Tu sai cosa significa. Noi lavoriamo per chi vive qui. Per chi resta. Per chi ci crede.

Non ti chiedo se vuoi farne parte — sei già parte di questo territorio e della sua trasformazione.

Ti chiedo: COME e QUANDO iniziamo?

Ho bisogno di te per:
• Costruire la presenza social di AI_COVO (Instagram, Facebook, LinkedIn, TikTok)
• Raccontare le storie vere del territorio — i ragazzi, gli anziani, le famiglie
• Piano editoriale etico e sostenibile — il tuo stile, la nostra missione
• Campagne locali che parlino alla gente, non agli algoritmi

Il progetto è già vivo: sito operativo (aicovo.tech), brand registrato, pitch al Comune in corso, primi donatori attivi. Manca la voce social. Manca la tua voce.

Ti propongo un caffè — anche domani — a Poggibonsi o a Colle. 30 minuti. Ti mostro tutto e decidiamo insieme il come.

Il compenso lo definiamo a voce. Non è un favore che ti chiedo: è un incarico professionale per un professionista che stimo.

LOCALS, Andrea. Siamo tutti locals qui.

Riccardo Rossi
Co-Founder & CEO
</AI_COVO.tech>®  — Digital Hub Sociale
aicovo.tech | WhatsApp: 327 383 9782
Colle Val d'Elsa (SI), Toscana`,
    },
    ciani: {
      destinatario: "Matteo Ciani — Brand Identity Designer",
      oggetto: "AI_COVO.tech® — La tua Val d'Elsa ha bisogno di un'identità, Matteo",
      corpo: `Matteo,

sono Riccardo Rossi, Co-Founder di AI_COVO.tech® — Digital Hub Sociale, nato qui in Val d'Elsa.

Non ti scrivo per caso. Ti scrivo perché sei di qui. Perché conosci ogni sfumatura di questo territorio — dalle colline del Chianti ai vicoli di Colle. E perché il tuo occhio grafico ha quella sensibilità che solo chi è cresciuto tra bellezza e concretezza toscana può avere.

AI_COVO è un progetto che sta per cambiare il modo in cui i piccoli comuni italiani pensano alla socialità. Doposcuola, formazione digitale, spazi per famiglie, inclusione degli anziani. Tutto sotto un brand che deve parlare di futuro senza dimenticare le radici.

Il brand esiste già — </AI_COVO.tech>® — total black, verde Matrix #00FF41, estetica brutalist. Ma ha bisogno di mani esperte per diventare un sistema visivo completo. Il tuo lavoro con le aziende del territorio, il vino, l'agricoltura — quella capacità di dare identità a chi ha una storia da raccontare — è esattamente ciò che ci serve.

Non ti chiedo se ti interessa. Ti chiedo come vuoi lavorarci.

Di cosa abbiamo bisogno:
• Brand Identity System completo (declinazioni logo, tipografia, palette estesa, iconografia)
• Template social per Instagram/Facebook/LinkedIn (per il nostro Social Media Manager)
• Materiali istituzionali (carta intestata, biglietti, presentazioni)
• Merchandising guideline (T-shirt, penne, cover — già in produzione)
• Brand book ufficiale per il franchising sociale nei comuni italiani

Il progetto è operativo: sito live, primi donatori, pitch istituzionali in corso, marchio in registrazione alla Camera di Commercio Arezzo-Siena.

Ti propongo un incontro — di persona, qui in Val d'Elsa. Un'ora. Ti faccio vedere tutto e definiamo tempi e compenso da professionisti.

Un progetto nato in Val d'Elsa merita un designer della Val d'Elsa.

Riccardo Rossi
Co-Founder & CEO
</AI_COVO.tech>® — Digital Hub Sociale
aicovo.tech | WhatsApp: 327 383 9782
Colle Val d'Elsa (SI), Toscana`,
    },
    comune: {
      oggetto: "Proposta di Collaborazione - AI_COVO Digital Hub Sociale per [NOME COMUNE]",
      corpo: `Gentilissimo/a Sindaco/Assessore,

mi permetto di contattarLa per presentare AI_COVO, un'innovativa iniziativa di Digital Hub Sociale nata a Colle Val d'Elsa con l'obiettivo di creare un modello replicabile in tutti i comuni italiani.

CHI SIAMO
AI_COVO è un'associazione culturale che trasforma spazi sfitti in centri nevralgici per la comunità, con particolare attenzione a:
• Doposcuola quotidiano (14:00-18:00)
• Formazione digitale per tutte le età
• Supporto a famiglie con ISEE basso
• Inclusione di anziani, immigrati e persone in difficoltà

IL PROBLEMA CHE AFFRONTIAMO
Una generazione di giovani "connessi" ai dispositivi ma "sconnessi" dalla realtà sociale. Mentre ci lamentiamo dei ragazzi sempre davanti agli schermi, non offriamo loro alternative concrete.

LA NOSTRA PROPOSTA
Vorremmo presentarLe il nostro progetto e valutare insieme la possibilità di:
1. Replicare il modello AI_COVO nel Vostro comune
2. Identificare spazi sfitti da riqualificare
3. Coinvolgere le associazioni locali

COSA OFFRIAMO
• Statuto e regolamento già pronti
• Brand kit completo
• Protocolli operativi testati
• Supporto all'avvio
• Network nazionale

Sarebbe disponibile per un incontro di 30 minuti per illustrarLe il progetto nel dettaglio?

Allego la presentazione completa e resto a disposizione per qualsiasi chiarimento.

Cordiali saluti,

[NOME COGNOME]
AI_COVO - Digital Hub Sociale
aicovo.tech
info@aicovo.it`,
    },
    anci: {
      oggetto: "AI_COVO - Proposta di Modello Replicabile per i Comuni Italiani",
      corpo: `Spett.le ANCI - Associazione Nazionale Comuni Italiani,

scriviamo per sottoporre alla Vostra attenzione AI_COVO, un progetto di Digital Hub Sociale nato a Colle Val d'Elsa (SI) con l'ambizione di diventare un modello replicabile per tutti i comuni italiani.

EXECUTIVE SUMMARY
AI_COVO affronta una criticità sociale sempre più urgente: una generazione di giovani iperconnessi digitalmente ma disconnessi dalla comunità reale. Offriamo una soluzione concreta attraverso la creazione di hub sociali che combinano doposcuola, formazione digitale e spazi di aggregazione intergenerazionale.

IL MODELLO "FRANCHISE SOCIALE"
Abbiamo sviluppato un sistema standardizzato che permette a qualsiasi comune di replicare il nostro modello:

1. DOCUMENTAZIONE COMPLETA
   - Statuto tipo
   - Regolamento operativo
   - Brand guidelines
   - Protocolli per ogni servizio

2. SOSTENIBILITÀ ECONOMICA
   - Quota associativa accessibile (19€/anno)
   - Corsi di formazione detraibili al 110%
   - Partnership con associazioni di categoria

3. IMPATTO SOCIALE MISURABILE
   - Riduzione dell'isolamento giovanile
   - Alfabetizzazione digitale intergenerazionale
   - Riqualificazione di spazi sfitti
   - Inclusione di categorie fragili

RICHIESTA
Chiediamo la possibilità di presentare il progetto in una sede istituzionale e di valutare:
• L'inserimento di AI_COVO tra le best practice da diffondere
• Un eventuale patrocinio ANCI
• La segnalazione ai comuni interessati

Siamo disponibili per un incontro presso la Vostra sede o in videoconferenza.

Distinti saluti,

[NOME COGNOME]
AI_COVO - Digital Hub Sociale
Colle Val d'Elsa (SI)
aicovo.tech | info@aicovo.it`,
    },
    farnesi: {
      destinatario: "Dott. Maurizio Farnesi — Direttore Generale ChiantiBanca",
      oggetto: "Art. 37 TUB + €29,3M di utili = AI_COVO chiede lo 0,102% per il territorio",
      corpo: `Gentilissimo Dott. Farnesi,

sono Riccardo Rossi, Co-Founder di AI_COVO.tech® — il primo Digital Hub Sociale d'Italia, nato a Colle Val d'Elsa.

Le scrivo per un motivo preciso: il vostro Bilancio 2025 e la legge.

I VOSTRI NUMERI (comunicato CdA del 25 marzo 2026)
• Utile netto 2025: €29.300.000
• Utile triennio: €99.200.000
• Soci: 34.400 (di cui 3.400 under 35, +1.500 nel 2024)
• Destinati under 35: €76.000.000
• Sponsorizzazioni territorio: €1.500.000 + €1.800.000 via ChiantiMutua
• CET1: 23,3% — solidita granitica

LA LEGGE CHE VI RIGUARDA
Art. 37, comma 1, TUB (D.Lgs. 385/1993): le BCC destinano almeno il 70% degli utili netti a riserva legale. Il residuo DEVE essere destinato "a fini di mutualita, beneficenza e sostegno di attivita di interesse comune nel territorio".
Art. 2514 c.c. + Art. 35 TUB: obbligo di operativita prevalente a favore di soci e comunita locali.
L. 49/2016 (Riforma BCC): conferma obbligo reinvestimento territoriale e mutualita prevalente.

Dott. Farnesi, non e una richiesta. E il vostro mandato statutario. Noi vi offriamo il progetto perfetto per adempierlo.

LA PROPOSTA: €30.000/anno per 10 anni

I NUMERI CHE CONTANO:
→ €30.000 = lo 0,102% dei vostri utili 2025. Su €29.300.000, sono €29.270.000. Che cambia?
→ €30.000 = il 2% delle vostre sponsorizzazioni annue (€1.500.000). Due per cento.
→ €300.000 in 10 anni con inflazione al 2% valgono €246.000 in potere d'acquisto reale.
→ 100% DEDUCIBILE fiscalmente (Art. 83 D.Lgs. 117/2017 — Terzo Settore).

IL NOSTRO PIANO DI SOSTENIBILITA:
• 2.500 soci obiettivo
• €20 tessera annua + €50 spesa media servizi = €70/socio/anno
• 2.500 x €70 = €175.000 di ricavi annui
• Dal 3° anno (1.000 soci): il progetto si AUTOFINANZIA
• In 10 anni generiamo €1.750.000 di ricavi vs €300.000 richiesti = ROI 583%

COSA FACCIAMO (e che rientra nel vostro mandato Art. 35 TUB):
• Doposcuola digitale quotidiano (14-18) per ragazzi
• Formazione digitale per tutte le eta — da SPID agli strumenti AI
• Inclusione sociale — anziani, famiglie ISEE basso, immigrati
• Stage retribuiti per under 35

COSA OTTIENE CHIANTIBANCA:
• Logo su T-shirt, attestati, eventi, merchandising
• Naming partner formazione ("powered by ChiantiBanca")
• Reportistica trimestrale impatto sociale
• Visibilita permanente su piattaforma web
• Case history perfetta per bilancio sociale BCC/Iccrea
• 2.500 soci = 2.500 ambasciatori del brand ChiantiBanca

Le Sue stesse parole: "L'efficienza di bilancio si puo sposare al meglio col sostegno continuo e costante a chi ci da fiducia."

Dott. Farnesi, la proposta completa con grafici, simulazioni e piano decennale e consultabile online:
→ aicovo.tech/chiantibanca (pagina riservata)

Le propongo 30 minuti — alla sede di Monteriggioni, a Colle, dove preferisce. Le mostro la piattaforma operativa e decidiamo insieme.

Con la piu sincera stima,

Riccardo Rossi
Co-Founder & CEO
</AI_COVO.tech>® — Digital Hub Sociale
aicovo.tech | WhatsApp: +39 327 383 9782
Colle Val d'Elsa (SI)

P.S. I miei saluti al Presidente Iacopozzi. Un progetto come AI_COVO — che adempie il mandato dell'Art. 37 TUB, genera un ROI sociale del 583%, e costa lo 0,102% dei vostri utili — merita almeno 30 minuti del vostro tempo.`,
    },
    sponsor: {
      oggetto: "Partnership AI_COVO - Digital Hub Sociale | Opportunità di CSR",
      corpo: `Gentile [NOME],

Le scrivo per proporLe un'opportunità di partnership con AI_COVO, un progetto di impatto sociale che sta nascendo a Colle Val d'Elsa con l'ambizione di espandersi a livello nazionale.

PERCHÉ AI_COVO È INTERESSANTE PER [AZIENDA]

1. IMPATTO REALE E MISURABILE
   Ogni euro investito si traduce in ore di doposcuola, corsi di formazione, spazi per famiglie in difficoltà. Report trasparenti e tracciabili.

2. VISIBILITÀ LOCALE E NAZIONALE
   Il nostro modello è progettato per replicarsi in migliaia di comuni. Il Vostro brand sarà associato a un movimento sociale innovativo.

3. COINVOLGIMENTO DEI DIPENDENTI
   Possibilità di attivare programmi di volontariato aziendale presso i nostri hub.

4. DEDUCIBILITÀ FISCALE
   Le donazioni alle associazioni culturali godono di benefici fiscali.

LIVELLI DI PARTNERSHIP

🥉 SOSTENITORE (€500)
   - Logo sul sito web
   - Menzione sui social

🥈 PARTNER (€2.000)
   - Tutto il livello precedente
   - Logo nelle sedi fisiche
   - Presentazione ai soci

🥇 MAIN SPONSOR (€5.000+)
   - Tutto il livello precedente
   - Naming di un'attività (es. "Doposcuola powered by [AZIENDA]")
   - Evento dedicato di presentazione

Sarebbe disponibile per una call di 20 minuti per approfondire?

Cordialmente,

[NOME COGNOME]
AI_COVO - Digital Hub Sociale
aicovo.tech`,
    }
  };

  const copyToClipboard = (text, type) => {
    try { navigator.clipboard.writeText(text).catch(() => { const a=document.createElement('textarea');a.value=text;document.body.appendChild(a);a.select();document.execCommand('copy');document.body.removeChild(a); }); } catch(e) { const a=document.createElement('textarea');a.value=text;document.body.appendChild(a);a.select();document.execCommand('copy');document.body.removeChild(a); }
    setCopied(type);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <main data-testid="email-page" className="pt-24 pb-16">
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-12">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-2">Email Templates</p>
          <h1 className="text-3xl font-bold mb-4">Email Pronte all'Invio</h1>
          <p className="text-zinc-400">Copia e personalizza queste email per contattare enti e comuni.</p>
        </div>

        {Object.entries(emails).map(([key, email]) => (
          <div key={key} className="mb-12 bg-[#0A0A0A] border border-white/10 p-8">
            <div className="flex justify-between items-start mb-6">
              <div>
                <span className="font-mono text-xs text-[#00FF41] uppercase tracking-wider">
                  {key === 'zammariello' && 'Social Media Manager — LOCALS'}
                  {key === 'ciani' && 'Brand Identity Designer — Val d\'Elsa'}
                  {key === 'farnesi' && 'CHIANTIBANCA — Partnership Strategica Decennale'}
                  {key === 'comune' && 'Per i Comuni'}
                  {key === 'anci' && 'Per ANCI'}
                  {key === 'sponsor' && 'Per Sponsor/Aziende'}
                </span>
                <h2 className="text-xl font-bold text-white mt-2">
                  {emails[key].destinatario ? (
                    <><span className="text-zinc-500 text-sm font-normal">A: </span>{emails[key].destinatario}<br/><span className="text-zinc-400 text-sm font-normal">Oggetto: </span>{email.oggetto}</>
                  ) : (
                    <>Oggetto: {email.oggetto}</>
                  )}
                </h2>
              </div>
              <button
                onClick={() => copyToClipboard(`Oggetto: ${email.oggetto}\n\n${email.corpo}`, key)}
                className={`btn-primary text-sm ${copied === key ? 'bg-[#00FF41] text-black' : ''}`}
              >
                {copied === key ? '✓ Copiato!' : 'Copia Email'}
              </button>
            </div>
            
            <div className="bg-black/50 p-6 font-mono text-sm text-zinc-300 whitespace-pre-wrap max-h-96 overflow-y-auto">
              {email.corpo}
            </div>
            
            <p className="text-zinc-500 text-xs mt-4">
              💡 Ricorda di personalizzare i campi tra [PARENTESI QUADRE]
            </p>
          </div>
        ))}

        <div className="text-center mt-12">
          <p className="text-zinc-500 mb-4">Hai bisogno di una versione personalizzata?</p>
          <a href="mailto:info@aicovo.it" className="btn-primary">Contattaci</a>
        </div>
      </div>
    </main>
  );
};

export default EmailPage;
